import React, { Fragment, useState, useEffect } from 'react';
import { BarChart2, BarChart, Layout} from 'react-feather';
import { Button, ButtonGroup, Card,Table, Col, Row, UncontrolledTooltip } from 'reactstrap';
import Properties from '../../components/modals/Properties';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { conversionDailyRequest } from '../../helpers/requests';
import ConversionGraph from './ConversionGraph';
import MainFilter from '../../components/filters/MainFilter';
import BarGraph from '../../components/tables/BarGraph';

const Conversion = () => {
    const [filters, setFilters] = useState();
    const [tooltip, setTooltip] = useState("");
    const [option, setOption] = useState([{ value: "sale", label: "Sale (PKR)" },]);
    const [currentView, setCurrentView] = useState("table");
    const [options, setOptions] = useState();
    const dispatch = useDispatch();
    // const filter = useSelector((state) => state.conversion.filter);
    // const total = useSelector((state) => state.conversion.total);
    const raw = useSelector((state) => state.conversion.dailyData);
    const loader = useSelector((state) => state.conversion.loader);
    const features = useSelector(state => state.auth.features);
    const { id, title } = useParams();
    const [data, setData] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [updateSidURL, setupdateSidURL] = useState();
    const [updateStoreNameURL, setupdateStoreNameURL] = useState();
    const [titles, setTitles] = useState(title)


    const updateFilter = (e) => {
        setupdateSidURL(e?.sid)
        setupdateStoreNameURL(e?.storeName)
        setFilters(e);
        var requestData = {
            params: {
                sid: [e?.sid],
                fid: e?.fid,
                start: e?.start,
                end: e?.end
            },
            dispatch: dispatch
        };
        conversionDailyRequest(requestData);
    }
    const getSalesData = () => {
        var requestData = {
             params: {
                sid: [filters?.sid],
                fid: filters?.fid,
                start: filters?.start,
                end: filters?.end
            },
            dispatch: dispatch
        };
        conversionDailyRequest(requestData);
    }

    useEffect(() => {
        if (filters) {
            setTimeout(() => {
                getSalesData();
            }, 100);
        }

    }, []);


    const numberWithCommas = (x) => {
        return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    useEffect(() => {
        setRawData(JSON.parse(JSON.stringify(raw)));
        const element = {};
        var _data = raw.map((element, index) => {
            element.sale = numberWithCommas(parseInt(element.sale));
            element.transaction = numberWithCommas(parseInt(element.transaction));
            element.units = numberWithCommas(parseInt(element.units));
            element.ipt = numberWithCommas(parseInt(element.ipt));
            element.atv = numberWithCommas(parseInt(element.atv));
            element.asp = numberWithCommas(parseInt(element.asp));
            element.conversion = element.conversion + "%";
            return element;
        }
        )
        // _data.shift();
        setData(_data);
    }, [raw])



    const [properties, setProperties] = useState([]);

    useEffect(() => {
        setProperties(option == null ? [] : option.map(opt => opt.value));
    }, [option])

    useEffect(() => {
        let allOptions = [...features.footfall, ...features.sales]
        setOption(allOptions)
        setOptions(allOptions)
    }, [features])

    const summaryMenu = [
        ["table", <Layout size={16} />, "Tabular View"],
        ["bar", <BarChart2 size={16} />, "Bar Chart"],
        ["bar2", <BarChart size={16} />, "Bar Board"]
    ];

    useEffect(() => {
        if (filters) {
            setupdateSidURL(filters?.sid)
            setupdateStoreNameURL(filters?.storeName)
        }
        if (updateSidURL && updateStoreNameURL ) {
            // window.history.pushState({}, '', `/conversions/${updateSidURL}/${updateStoreNameURL}`);
            window.history.replaceState({}, '', `/conversions/${updateSidURL}/${updateStoreNameURL}`)
        }
    }, [filters])

    useEffect(() => {
        if (updateStoreNameURL) {
            setTitles(updateStoreNameURL)
        }
    }, [updateStoreNameURL])


    return (
        <Fragment>
            <MainFilter pageTitle="Conversion" updateStoreNameURL={titles} updateFilter={(e) => updateFilter(e)} type="" />

            <Row >
                <Col>
                    <h4 className="my-3">Conversion | {titles} </h4>
                </Col>
            </Row>
            <Row className='mb-4'>
                {option && options &&
                    <Col className='text-start'>
                        <Properties option={option} options={options} setOption={(e) => setOption(e)} />
                    </Col>
                }
                <Col className='text-end'>
                    <ButtonGroup>
                        {
                            summaryMenu.map((val, index) => {
                                return (
                                    <Button
                                        href={"#toggle-tab-" + val[0]}
                                        color={currentView == val[0] ? "outline-primary" : "outline-light"}
                                        className='section-tab'
                                        size='sm'
                                        onClick={function noRefCheck() { setCurrentView(val[0]) }}
                                        active={currentView == val[0] ? true : null}
                                        key={"compare-tab-" + index}
                                        id={"toggle-tooltip-" + val[0]}
                                        // onMouseOver={() => setTooltip(val[0])}
                                        // onMouseOut={() => setTooltip(null)}
                                    >
                                        {val[1]}
                                    </Button>
                                );
                            })
                        }
                    </ButtonGroup>
                    {
                        summaryMenu.map((val, index) => {
                            return (
                                <UncontrolledTooltip
                                    flip
                                    isOpen={val[0] == tooltip}
                                    autohide={false}
                                    placement='top'
                                    target={"toggle-tooltip-" + val[0]}
                                    key={"compare-tab-tooltip-" + index}
                                >
                                    {val[2]}
                                </UncontrolledTooltip>
                            );
                        })
                    }
                </Col>
            </Row>

           
            <div style={{ minHeight: "500px" }}>
                {
                    currentView === "table" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <Card style={{ border: 'none' }}>
                                <Table bordered style={{ fontSize: "14px", textAlign: "center" }}>
                                    <thead>
                                        <tr>
                                            <th className='pointer'>Label</th>
                                            {
                                                option.map((key, index) => {
                                                    return <th className='pointer select-none' style={{ paddingLeft: "1rem" }} key={"main-table-th-" + index}> {key.label}</th>
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody style={{ borderTop: "none" }}>
                                        {
                                            data.map((row, index) => {

                                                return <tr key={"main-table-" + index}>
                                                    <td>{row.label}</td>
                                                    {
                                                        option.map((key, index) => {
                                                            return <td key={"main-table-td-" + index}>{row[key.value === 'unis' ? "units" : key.value]}</td>
                                                            //  return <td key={"main-table-td-" + index}>{row[key.value]}</td>
                                                        })
                                                    }
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                }

                {
                    currentView === "bar" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView}>
                        <Col>
                            <ConversionGraph title={options} payload={rawData} properties={properties} />
                        </Col>
                    </Row>
                }
                {
                    currentView === "bar2" && option &&
                    <Row className='mb-4' id={"#toggle-tab-" + currentView} >
                        <Col>
                            <BarGraph dataOptions={option} title={options} payload={rawData} properties={properties} />
                        </Col>
                    </Row>
                }
            </div>
        </Fragment>
    );
}

export default Conversion;
